// extracted by mini-css-extract-plugin
export default {"icon":"DrawButton_icon__Bo5mM","drawButton":"DrawButton_drawButton__TH0ZM"};